import { ColumnFieldEditor } from "./components/Steps/DashboardFields/Editors/ColumnFieldEditor";
import { CustomFieldFieldEditor } from "./components/Steps/DashboardFields/Editors/CustomFieldFieldEditor";
import { SubscriptionFieldEditor } from "./components/Steps/DashboardFields/Editors/SubscriptionFieldEditor";
import { FieldEditorProps } from "./components/Steps/DashboardFields/Editors/FieldEditorProps";
import { GoalFieldEditor } from "./components/Steps/DashboardFields/Editors/GoalFieldEditor";
import { SearchFieldEditor } from "./components/Steps/DashboardFields/Editors/SearchFieldEditor";
import { SurveyFieldEditor } from "./components/Steps/DashboardFields/Editors/SurveyFieldEditor";
import { AnswerableQuestionEditor } from "./components/Steps/DashboardFields/Editors/AnswerableQuestionEditor";
import { OrganisationFieldEditor } from "./components/Steps/DashboardFields/Editors/OrganisationFieldEditor";

type FieldMapItem = {
  label: string;
  source: string;
  editorComponent: (props: FieldEditorProps) => JSX.Element;
  requiredFields: string[];
  // Optional field to indicate if this should be hidden from the field type dropdown. Used for special cases like resubscription that aren't selectable directly but still need an editor.
  // Null when no field selected (i.e. AddField). FieldMapItem when selected (i.e. SourceSelector)
  hiddenOnSelectedField?: (field: FieldMapItem|null) => boolean;
};

const FieldMap: FieldMapItem[] = [
  {
    label: "Field",
    source: "column",
    editorComponent: ColumnFieldEditor,
    requiredFields: ['column'],
  },
  {
    label: "Custom Field",
    source: "custom_field",
    editorComponent: CustomFieldFieldEditor,
    requiredFields: ['customFieldId'],
  },
  {
    label: "Organisation",
    source: "organisation",
    editorComponent: OrganisationFieldEditor,
    requiredFields: ['organisationKind'],
  },
  {
    label: "Subscription",
    source: "subscription",
    editorComponent: SubscriptionFieldEditor,
    requiredFields: ['subscriptionTopics', 'organisationKind'],
    // Always show, unless the resubscription is going to be shown instead
    hiddenOnSelectedField: (field) => field?.source === 'resubscription', 
  },
  {
    label: "Subscription",
    source: "resubscription",
    editorComponent: SubscriptionFieldEditor,
    requiredFields: ['subscriptionTopics', 'organisationKind'],
    // Essentially always hide, unless it's literally this selected one 
    hiddenOnSelectedField: (field) => field?.source !== 'resubscription', 
  },
  {
    label: "Goal",
    source: "goal",
    editorComponent: GoalFieldEditor,
    requiredFields: ['goalId'],
    hiddenOnSelectedField: (field) => field?.source === 'completable_goal',
  },
  {
    label: "Goal",
    source: "completable_goal",
    editorComponent: GoalFieldEditor,
    requiredFields: ['goalId'],
    hiddenOnSelectedField: (field) => field?.source !== 'completable_goal',
  },
  {
    label: 'Audience',
    source: 'search',
    editorComponent: SearchFieldEditor,
    requiredFields: ['searchId'],
  },
  {
    label: 'Survey Response',
    source: 'survey_response',
    editorComponent: SurveyFieldEditor,
    requiredFields: ['questionId'],
  },
  {
    label: 'Answer Question',
    source: 'answerable_question',
    editorComponent: AnswerableQuestionEditor,
    requiredFields: ['questionId'],
  }
];

export default FieldMap;
